<template>
	<div class="monitoring__columns" v-if="getSelectedCompany()">
		<location-column v-for="location of monitored_locations" :key="location.id" :location="location"></location-column>
	</div>
</template>
<script>
import company_service from '../../../services/company_service';
import LocationColumn from './LocationColumn.vue';
export default {
  components: {
    'location-column': LocationColumn,
  },
  data() {
    return {
      monitored_locations: [],
    };
  },
  mounted() {
    this.getCompanies();
  },
  methods: {
    getCompanies() {
      const vm = this;
      try {
        company_service.getCompanies(
          {
            user_id: this.getUserId(),
          },
          {
            'X-Device-ID': this.getDeviceId(),
          }
        ).then(function (response) {
            vm.updateSelectedCompany(null)
            let companies = [];
            response.data.forEach(data => {
              let filter_locations = []
              let locations = data.monitored_locations.sort((a, b) => a.pending_events - b.pending_events).reverse();
              locations.forEach(loc => {
                filter_locations.push({
                  id: loc.id,
                  name: loc.name,
                  pending_events: loc.pending_events,
                  sublocations: loc.sublocations,
                  new_event_validator: false,
                  speaker: loc.speaker
                })
              })
              companies.push({
                id: data.company.id,
                icon: 'apartment',
                name: data.company.name,
                route: 'monitoring',
                hikcentral_streaming_link: data.company.hikcentral_streaming_link,
                monitored_locations: filter_locations,
                pending_events: data.company.total_pending_events,
                monitoring_calls: data.company.monitoring_calls,
                dynamic_invitations: data.company.dynamic_invitations,
                remote_open_door: data.company.remote_open_door,
                remote_comunications: data.company.remote_comunications,
                perimetral_alerts: data.company.perimetral_alerts,
                new_event_validator: false
              });
            });
            let sortedCompaniesByEvents = companies.filter((company) => company.pending_events > 0).sort((a, b) => a.pending_events - b.pending_events).reverse().concat(companies.filter((company) => company.pending_events <= 0))
            vm.updateMonitoredCompanies(sortedCompaniesByEvents);
            vm.updateSelectedCompany(6); //<-----Update company for monitoring
            //vm.updateSelectedCompany(70); //<-----Update company for monitoring
            vm.getMonitoredLocations();

            if (response.data.meta) {
              if (response.data.meta.authentication_token) {
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function (response) {
            if (response.data.meta) {
              if (response.data.meta.authentication_token) {
                this.checkToken(response.data.meta.authentication_token)
              }
            }
          })
      } catch (e) {
        alert(e.message)
      }
    },
    getMonitoredLocations() {
      this.monitored_locations = this.getMonitoredCompanies().find(e => e.id === this.getSelectedCompany()).monitored_locations;
    },
  }
}
</script>